<template>
  <div class="content-wrapper">
    <h2 class="page-titles">Add invoicing details</h2>
    <div class="arrow-link">
      <router-link :to="{ name: 'billing', query: { tab: 'payment' } }">
        <span>Go Back to payments</span>
      </router-link>
    </div>
    <form @submit.prevent="invoiceMethodCreation">
      <section class="form-holder">
        <!-- First Name Here -->
        <div class="form-group inline-inputs">
          <input
            type="text"
            placeholder="First name *"
            class="form-control"
            v-model="newInvoiceMethod.firstName"
          />
        </div>

        <!-- Last Name Here -->
        <div class="form-group">
          <input
            type="text"
            placeholder="Last name *"
            class="form-control"
            v-model="newInvoiceMethod.lastName"
          />
        </div>

        <!-- Email  Here -->
        <div class="form-group">
          <input
            type="email"
            placeholder="Accounts payable email *"
            class="form-control"
            v-model="newInvoiceMethod.accountEmail"
          />
        </div>

        <!-- Phone  Here -->
        <div class="form-group">
          <input
            type="tel"
            placeholder="Accounts payable phone *"
            class="form-control"
            v-model="newInvoiceMethod.accountPhone"
          />
        </div>
      </section>

      <div class="text-left flex justify-center" style="padding-top: 1rem">
        <button
          class="button-gemnote button-gemnote--small"
          :class="{ 'button-gemnote--disabled': submittingPaymentMethod }"
          :disabled="submittingPaymentMethod"
        >
          <span>Save payment method</span>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { layouts, paymentMethodType } from '../../helpers'

export default {
  name: 'AddInvoicePaymentMethod',
  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD)
  },
  computed: {
    ...mapState({
      newInvoiceMethod: state => state.billing.newInvoiceMethod,
      submittingPaymentMethod: state => state.billing.submittingPaymentMethod
    })
  },
  methods: {
    invoiceMethodCreation() {
      let errors = []

      // validates first name
      if (
        this.newInvoiceMethod.firstName.trim() === '' ||
        this.newInvoiceMethod.firstName === null
      ) {
        errors.push({ error: `First name can't be blank` })
      }

      // validates last name
      if (
        this.newInvoiceMethod.lastName.trim() === '' ||
        this.newInvoiceMethod.lastName === null
      ) {
        errors.push({ error: `Last name can't be blank` })
      }

      // validates account email
      if (
        this.newInvoiceMethod.accountEmail.trim() === '' ||
        this.newInvoiceMethod.accountEmail === null
      ) {
        errors.push({ error: `Account email can't be blank` })
      }

      // validates account email
      if (
        this.newInvoiceMethod.accountPhone.trim() === '' ||
        this.newInvoiceMethod.accountPhone === null
      ) {
        errors.push({ error: `Account phone can't be blank` })
      }

      if (errors.length) {
        this.$store.dispatch('notification/pushNotification', {
          type: 'error',
          messages: errors.map(item => item.error)
        })
        return
      }

      this.$store.dispatch('billing/addPaymentMethod', {
        paymentType: paymentMethodType.INVOICE,
        invoiceInfo: this.newInvoiceMethod,
        stripeToken: null
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.arrow-link {
  margin-top: 4rem;
}

.button-gemnote {
  margin-top: 1.25rem;
  font-size: 0.813rem;
  height: 2.5rem;
  padding: 0 1rem;
}

form {
  width: 42%;
  margin: 1.5rem auto;

  .form-holder {
    border-left: 1px solid $onyx;
    border-right: 1px solid $onyx;
    border-top: 1px solid $onyx;
  }

  .form-group {
    margin-bottom: unset !important;
  }

  input {
    padding: 28px 20px !important;

    &::placeholder {
      color: #9b9b9b;
      font-size: 0.813rem;
      text-transform: uppercase;
    }
  }
}

.inline-inputs {
  display: flex;
  gap: 1rem;
}

@media (max-width: 900px) {
  form {
    width: 100%;
  }
}
</style>
